module.exports = __webpack_public_path__ + "img/Synolia_LOGO_small.a31c5bb3.png";